import React from 'react';
import styled from 'styled-components';


// ************ REQUIRED ON ITEM ************
// :hover {
//     .tooltip{
//         visibility: visible;
//         transition-property: visibility;
//         transition-delay: 0.7s;
//     }
// }
// ************ REQUIRED ON ITEM ************

const CustomTooltipContainer = styled.div`
    position:relative;
    z-index:100;
    visibility: hidden;
    transition-property: visibility;
    transition-delay: 0.2s;
    display:flex;
    justify-content:center;
    &>.tooltipContentWrapper{
        position:absolute;
        
        &>span{
            margin-top:${props => props.$marginTop ? props.$marginTop : "0.95rem"};
            margin-left:${props => props.$xDisposition ? props.$xDisposition : ""};
            padding:0.6rem;
            position: absolute;
            background-color:var(--extra-light-gray);
            border-radius:0.4rem;
            .tooltipContentText{
                color:var(--gray);
                font-size:0.9rem;
                width: max-content;
                max-width:14rem;
                white-space: pre-wrap;
            }
            .arrowEffect{
                transform: rotate(45deg);
                position:absolute;
                left:1rem;
                top:-0.5rem;
                width:1rem;
                height:1rem;
                background-color:var(--extra-light-gray);
            }
        }
    }
`
// margin-top: ${props => props.$marginTop ? props.$marginTop : "0.75rem" };
export const CustomTooltip = ({info, marginTop, xDisposition, customClassName}) => {
    
    return <CustomTooltipContainer className={`${customClassName} tooltip`}  $marginTop={marginTop} $xDisposition={xDisposition}>
        <span className='tooltipContentWrapper'>
            <span>
                <span className='arrowEffect'></span>
                <div className="tooltipContentText">
                    {info}
                </div>
            </span>
        </span>
    </CustomTooltipContainer>
}